export default __webpack_public_path__ + "static/media/companies-benefits-01.d5917cfc.webp";